import ApiErrorResponse from "@eryxcoop/appyx-comm/src/responses/generalResponses/ApiErrorResponse";

export default class DeletedOrderErrorResponse extends ApiErrorResponse {
    static defaultResponse() {
        return {
            object: {
            },
            errors: [
                {
                    'code': 'order_was_deleted',
                    'text': "Order was deleted"
                }
            ]
        }
    }

    static errorCodes() {
        return ['order_was_deleted'];
    }

    orderWasDeleted() {
        return true;
    }
}